import { createAction } from '@reduxjs/toolkit';

export const userHelperActions = {
	hydrateUser: createAction<{ wallet_address: string }>(`user/hydrate`),
};
